import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import cn from 'classnames'
import { CSSTransition } from 'react-transition-group'

import styles from './countdown_screen_number.scss'

class CountdownScreenNumber extends PureComponent {

	render() {
		return (
			<div
				styleName={
					cn({
						'screen-time': true,
						'screen-time-violet': this.props.color === 'violet',
						'screen-time-red': this.props.color === 'red',
						'screen-time-yellow': this.props.color === 'yellow',
						'screen-time-green': this.props.color === 'green',
						'screen-time-transparent': this.props.transparent === true,
					})
				}>
				<CSSTransition
					in
					appear
					classNames={{
						appear: styles.appear,
						appearActive: styles['appear-active'],
					}}
					timeout={1500}
				>
					<div styleName='screen-time-text'>
						{this.props.value}
					</div>
				</CSSTransition>
			</div>
		)
	}
}

CountdownScreenNumber.defaultProps = {
	transparent: false,
}

export default CSSModules(CountdownScreenNumber, styles, {allowMultiple: true})
